import { gql } from '@apollo/client'

export const FulfilSaleMutation = gql`
  mutation FulfilSaleMutation($saleId: ID!, $type: FulfilmentType!) {
    fulfilSale(saleID: $saleId, fulfilmentType: $type) {
      id
      status
    }
  }
`
